<template>
    <article :class="[modal ? 'is-modal' : 'panel is-primary']">
        <div class="panel-heading">
            <p>{{ title }}</p>
            <button
                v-if="action" 
                class="button" 
                :disabled="actionDisabled"
                @click.prevent="$emit('click')"
            >
                {{ action }}
            </button>
        </div>
        <div class="panel-block">
            <slot></slot>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        action: {
            type: String,
        },
        actionDisabled: {
            type: Boolean,
            default: false,
        },
        modal: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style lang="scss" scoped>
.panel-heading {
    font-size: 1em;
    font-weight: 600;
    padding: 0.3em 0.75em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    p {
        margin-bottom: 0;
    }
}

.panel-block {
    flex-direction: column;
    align-items: flex-start;
}

.table {
    tbody tr td {
        padding: 1px 0;
        width: 50%;
    }
}

.is-modal {
    border: solid;
    border-width: 1px;
    border-color: lightgrey;
}
</style>
